import "core-js/modules/es.array.push.js";
import BatterTableDataView from "@/components/BatterTableDataView";
import api from "@/api";
export default {
  name: "HomeWorkView",
  components: {
    BatterTableDataView
  },
  data() {
    return {
      nowTs: new Date().getTime()
    };
  },
  methods: {
    reviewHw(workId, row) {
      api.startTplWorkById(workId).then(ret => {
        console.log(ret, row);
        this.$router.push({
          name: 'TrainAnswerView',
          params: {
            subject: ret.subject,
            examId: ret.examId
          },
          query: {
            roomId: row.data.roomId,
            tplId: row.data.tplId
          }
        });
      });
    },
    startHw(workId, row) {
      api.startTplWorkById(workId).then(ret => {
        console.log(ret, row);
        this.$router.push({
          name: 'TrainAnswerView',
          params: {
            subject: ret.subject,
            examId: ret.examId
          },
          query: {
            roomId: row.data.roomId,
            tplId: row.data.tplId
          }
        });
      });
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};